export const FUNDING_ROUNDS = [
	{ id: "seed", title: "Seed" },
	{ id: "debt_financing", title: "Debt Financing" },
	{ id: "angel", title: "Angel" },
	{ id: "venture", title: "Venture" },
	{ id: "series_a", title: "Series A" },
	{ id: "series_b", title: "Series B" },
	{ id: "series_c", title: "Series C" },
	{ id: "series_d", title: "Series D" },
	{ id: "series_e", title: "Series E" },
	{ id: "series_f", title: "Series F" },
	{ id: "series_g", title: "Series G" },
	{ id: "series_h", title: "Series H" },
	{ id: "other", title: "Other" },
];

export const FUNDING_MIN_OPTIONS = [
	{ label: "Any", value: null },
	{ label: "$0", value: 0 },
	{ label: "$1M", value: 1_000_000 },
	{ label: "$5M", value: 5_000_000 },
	{ label: "$10M", value: 10_000_000 },
	{ label: "$25M", value: 25_000_000 },
	{ label: "$50M", value: 50_000_000 },
	{ label: "$100M", value: 100_000_000 },
	{ label: "$250M", value: 250_000_000 },
	{ label: "$500M", value: 500_000_000 },
];

export const FUNDING_MAX_OPTIONS = [
	{ label: "Any", value: null },
	{ label: "$1M", value: 1_000_000 },
	{ label: "$5M", value: 5_000_000 },
	{ label: "$10M", value: 10_000_000 },
	{ label: "$25M", value: 25_000_000 },
	{ label: "$50M", value: 50_000_000 },
	{ label: "$100M", value: 100_000_000 },
	{ label: "$250M", value: 250_000_000 },
	{ label: "$500M", value: 500_000_000 },
	{ label: "$1B", value: 1_000_000_000 },
];
